import { api } from '../../api/api';
import {
  QBO_REQUEST, QBO_STATUS_SUCCESS, QBO_CUSTOMERS_SUCCESS,
  QBO_CUSTOMER_SEARCH_SUCCESS, QBO_CUSTOMER_DETAIL_SUCCESS,
  QBO_SYNC_SUCCESS, QBO_INVOICES_SUCCESS, QBO_ITEMS_SUCCESS,
  QBO_DISCONNECT_SUCCESS, QBO_FLAG_OFF, QBO_REQUEST_FAILED,
} from '../constant';

/** QBO 연결 상태 확인 */
export const getQboStatus = () => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.get('/qbo/status');
    dispatch({ type: QBO_STATUS_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/** OAuth 인증 URL 가져오기 (리다이렉트용) */
export const getQboAuthUrl = () => async (dispatch) => {
  try {
    const { data } = await api.get('/qbo/auth-url');
    console.log('[QBO] Auth URL:', data.authUrl);
    if (!data.authUrl || !data.authUrl.includes('redirect_uri=')) {
      console.error('[QBO] redirect_uri missing from auth URL!', data.authUrl);
      dispatch({ type: QBO_REQUEST_FAILED, payload: 'redirect_uri가 서버에 설정되지 않았습니다. Admin Settings에서 확인하세요.' });
      return;
    }
    window.location.href = data.authUrl;
  } catch (e) {
    console.error('QBO Auth URL error:', e);
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/** QBO 연결 해제 */
export const disconnectQbo = () => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    await api.post('/qbo/disconnect');
    dispatch({ type: QBO_DISCONNECT_SUCCESS });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/**
 * QBO 고객 목록 조회
 * @param {{ all?: boolean, start?: number, max?: number }|number} opts - 숫자만 넘기면 레거시: (start, max) 중 start로 취급하지 않음. 객체 권장.
 */
export const getQboCustomers = (opts = {}) => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    let q;
    if (typeof opts === 'number') {
      q = `start=${opts}&max=100`;
    } else if (opts && opts.all) {
      q = 'all=true';
    } else {
      const start = opts.start ?? 1;
      const max = opts.max ?? 100;
      q = `start=${start}&max=${max}`;
    }
    const { data } = await api.get(`/qbo/customers?${q}`);
    dispatch({ type: QBO_CUSTOMERS_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/** QBO 고객 검색 */
export const searchQboCustomers = (query) => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.get(`/qbo/customers/search?q=${encodeURIComponent(query)}`);
    dispatch({ type: QBO_CUSTOMER_SEARCH_SUCCESS, payload: data.customers });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/** QBO 고객 상세 조회 (주소 자동 입력용) */
export const getQboCustomer = (customerId) => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.get(`/qbo/customers/${customerId}`);
    dispatch({ type: QBO_CUSTOMER_DETAIL_SUCCESS, payload: data.customer });
    return data.customer;
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
    return null;
  }
};

/** QBO 고객 → Store 동기화 */
export const syncQboCustomer = (customerId, additionalData = {}) => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.post('/qbo/sync/customers', { customerId, additionalData });
    dispatch({ type: QBO_SYNC_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
    return null;
  }
};

/** 전체 고객 일괄 동기화 */
export const syncAllQboCustomers = () => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.post('/qbo/sync/customers', { all: true });
    dispatch({ type: QBO_SYNC_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
    return null;
  }
};

/** QBO 인보이스 목록 */
export const getQboInvoices = () => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.get('/qbo/invoices');
    dispatch({ type: QBO_INVOICES_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

/** QBO 아이템 목록 */
export const getQboItems = () => async (dispatch) => {
  dispatch({ type: QBO_REQUEST });
  try {
    const { data } = await api.get('/qbo/items');
    dispatch({ type: QBO_ITEMS_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: QBO_REQUEST_FAILED, payload: e.response?.data?.message || e.message });
  }
};

export const qboFlagOff = () => ({ type: QBO_FLAG_OFF });
